(function () {
  'use strict';

  var LS_KEY = 'cs_pincode';

  /* ── SVG icons ── */
  var ICO_OK = '<svg class="cs-pincheck__card-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>';
  var ICO_ERR = '<svg class="cs-pincheck__card-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>';
  var ICO_TRUCK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  var ICO_CHECK_SM = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function deliveryDate(days) {
    var d = new Date();
    d.setDate(d.getDate() + parseInt(days, 10));
    return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
  }

  function renderLoading() {
    return '<div class="cs-pincheck__card cs-pincheck__card--loading">' +
      '<div class="cs-pincheck__dots"><span></span><span></span><span></span></div>' +
      '<span class="cs-pincheck__loading-text">Checking availability…</span>' +
    '</div>';
  }

  function renderSuccess(city, date) {
    return '<div class="cs-pincheck__card cs-pincheck__card--ok">' +
      '<div class="cs-pincheck__card-header">' +
        ICO_OK +
        '<span class="cs-pincheck__card-title">Shipping to <strong>' + esc(city) + '</strong></span>' +
      '</div>' +
      '<div class="cs-pincheck__card-date">' +
        ICO_TRUCK +
        '<span>Estimated delivery by <strong>' + date + '</strong></span>' +
      '</div>' +
    '</div>';
  }

  function renderError(city) {
    var loc = city ? ' to <strong>' + esc(city) + '</strong>' : '';
    return '<div class="cs-pincheck__card cs-pincheck__card--err">' +
      '<div class="cs-pincheck__card-header">' +
        ICO_ERR +
        '<span class="cs-pincheck__card-title">Delivery not available' + loc + '</span>' +
      '</div>' +
    '</div>';
  }

  function renderInputError(msg) {
    return '<div class="cs-pincheck__card cs-pincheck__card--err">' +
      '<div class="cs-pincheck__card-header">' +
        ICO_ERR +
        '<span class="cs-pincheck__card-title">' + esc(msg) + '</span>' +
      '</div>' +
    '</div>';
  }

  function init(wrap) {
    var worker = wrap.dataset.worker;
    var weight = wrap.dataset.weight || '500';
    var input  = wrap.querySelector('.cs-pincheck__input');
    var btn    = wrap.querySelector('.cs-pincheck__btn');
    var result = wrap.querySelector('.cs-pincheck__result');

    function setLoading(on) {
      btn.disabled = on;
      if (on) {
        btn.classList.add('cs-pincheck__btn--loading');
      } else {
        btn.classList.remove('cs-pincheck__btn--loading');
      }
    }

    function check(pin) {
      result.innerHTML = renderLoading();
      setLoading(true);

      fetch(worker + '/serviceability?pincode=' + pin + '&weight=' + weight)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          localStorage.setItem(LS_KEY, pin);
          if (data.serviceable) {
            var date = deliveryDate(5);
            var city = data.city || pin;
            result.innerHTML = renderSuccess(city, date);
          } else {
            result.innerHTML = renderError(data.city || null);
          }
        })
        .catch(function () {
          result.innerHTML = renderInputError('Unable to check. Please try again.');
        })
        .finally(function () {
          setLoading(false);
        });
    }

    function tryCheck() {
      var pin = input.value.trim();
      if (!/^\d{6}$/.test(pin)) {
        result.innerHTML = renderInputError('Please enter a valid 6-digit pincode.');
        return;
      }
      check(pin);
    }

    btn.addEventListener('click', tryCheck);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') tryCheck(); });
    input.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, 6);
    });

    // Auto-fill + auto-check saved pincode
    var saved = localStorage.getItem(LS_KEY);
    if (saved && /^\d{6}$/.test(saved)) {
      input.value = saved;
      check(saved);
    }
  }

  function initAll() {
    document.querySelectorAll('.cs-pincheck:not([data-cs-init])').forEach(function (el) {
      el.dataset.csInit = '1';
      init(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
